import { Text, View } from '@react-pdf/renderer'
import { tw } from '~/components/pdfs'
import { cn } from '~/utils'

export type TableColumnConfig = {
  key: string
  label: string
  basis?: number
  formatter?: (value: number) => string | React.ReactNode
}

export type CompTableConfig = {
  columns: TableColumnConfig[]
}

type CompTableProps = {
  data: Record<string, any>[]
  config: CompTableConfig
}

export function CompTable({ data, config }: CompTableProps) {
  // Filter columns to only include those with data
  const filteredColumns = config.columns.filter((column) =>
    data.some((row) => row[column.key] != null && row[column.key] !== '')
  )

  const defaultFormatter = (value: any) => {
    if (value == null || value === '') return '-'
    return String(value)
  }

  return (
    <View style={tw('flex flex-row')}>
      {filteredColumns.map((column, index) => (
        <View
          key={column.key}
          style={tw(
            index === 0
              ? 'basis-5/12'
              : column.basis
                ? `basis-${column.basis}/12`
                : 'basis-2/12'
          )}>
          <View
            style={tw(
              cn(
                'flex flex-col justify-end border-b border-gray-200 pb-1',
                index < filteredColumns.length - 1 && 'pr-4'
              )
            )}>
            <Text style={tw('font-sans text-sm font-medium')}>
              {column.label}
            </Text>
          </View>
          {data.map((row, rowIndex) => {
            const rawValue = row[column.key]
            const value =
              typeof rawValue === 'object'
                ? rawValue
                : column.formatter
                  ? column.formatter(rawValue)
                  : defaultFormatter(rawValue)

            return (
              <View
                wrap={false}
                key={`${row._id || rowIndex}-${column.key}`}
                style={tw(
                  cn(
                    'flex h-[24px] flex-row items-center justify-between gap-2 pb-[2px] pr-2 text-sm',
                    rowIndex % 2 === 1 && 'bg-gray-100'
                  )
                )}>
                {typeof value === 'object' ? (
                  <>{value}</>
                ) : (
                  <Text style={tw('font-sans')}>{value}</Text>
                )}
              </View>
            )
          })}
        </View>
      ))}
    </View>
  )
}
